export default __webpack_public_path__ + "static/media/L0000.fe69c995.png";